<template>
  <div class="container">
<br>
    <div class="jumbotron">
  <h1 class="display-4">Resultado parcial</h1>
  <br>
  <h3>{{tituloFormulario}}</h3>

  <br>
  <h5>{{tituloPergunta}}</h5>
  <hr class="my-4">

  <div class="row">
      <div class="col">

      <table class="table table-bordered" style="font-size:18pt">
      <tbody>
        <tr :key="index" v-for="(resposta,index) in respostas">
          <th>
            {{resposta.valorResposta}}
          </th>
          <th>
            {{resposta.total}}
          </th>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th>Total</th>
          <th>{{totaApuracao}}</th>
        </tr>
      </tfoot>
    </table>
      </div>
    </div>
  <span v-if="votacaoEncerrada" class="badge badge-danger">Votação encerrada.</span>
  <div class="row" style="display:none">
    <div class="col">
      proxima atualização em: <span class="badge badge-info">{{(tempoMaximo - contador)}}</span> <span>segundo(s)</span>
    </div>
  </div>

</div>

  </div>
</template>

<script>
import FormularioService from '../services/FormularioService'
const tempoMaximo = 6

export default {
  name: 'apuracao-page',
  data () {
    return {
      respostas: [],
      totaApuracao: 0,
      contador: 0,
      tituloPergunta: '',
      tituloFormulario: '',
      tempoMaximo: tempoMaximo,
      votacaoEncerrada: false,
      timerAtualizacao: null
    }
  },
  methods: {
    async refreshApuracao () {
      let respostas = await FormularioService.obterApuracao(this.$route.params.formId)
      this.respostas = respostas
      let pergunta = {}
      let totalRespostas = 0
      if (Array.isArray(respostas)) {
        pergunta = respostas[0]
        totalRespostas = pergunta.totalInteracao
        this.tituloPergunta = pergunta.tituloPergunta
        this.tituloFormulario = pergunta.tituloFormulario
        this.votacaoEncerrada = !pergunta.ativo
        if (this.votacaoEncerrada) {
          clearInterval(this.timerAtualizacao)
        }
      }

      this.totaApuracao = totalRespostas
      this.tempoMaximo = tempoMaximo
      this.contador = 1
    }
  },
  async created () {
    this.refreshApuracao()
  },
  mounted () {
    if (!(this.respostas && this.respostas.length)) {
      this.timerAtualizacao = setInterval(() => {
        if (this.contador === tempoMaximo) {
          this.refreshApuracao()
        } else {
          this.contador++
        }
      }, (1000))
    }
  }
}
</script>

<style>
@import url('../assets/gradiente.css');
</style>



// WEBPACK FOOTER //
// src/View/ApuracaoPage.vue